import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';

const InstagramFollowTrackerSub = dynamic(() => import('@/components/LandingPage/InstagramFollowTrackerSub'), {
  ssr: true,
});
const WebViewerForInstagramSub = dynamic(
  () => import('@/components/web-viewer-for-instagram/WebViewerForInstagramSub'),
  {
    ssr: true,
  }
);
const InstagramHashtagGeneratorSub = dynamic(
  () => import('@/components/InstagramHashtagGenerator/InstagramHashtagGeneratorSub'),
  {
    ssr: true,
  }
);
const InstagramTrackerSubContent = dynamic(() => import('@/components/LandingPage/InstagramTrackerSub'), {
  ssr: true,
});
const DownloadInstagramStoryContent = dynamic(() => import('@/components/LandingPage/DownloadInstagramStorySub'), {
  ssr: true,
});

const LandingPageMainContent = ({ data }: { data?: any }) => {
  const getContent = useMemo(() => {
    const functionData = data?.contentData?.function;

    console.log({ functionData });
    switch (functionData) {
      case 'recent_follow':
        return <InstagramFollowTrackerSub data={data} />;
      case 'hashtag':
        return <InstagramHashtagGeneratorSub data={data} />;
      case 'ins_post':
        return <WebViewerForInstagramSub data={data} />;
      case 'story':
        return <DownloadInstagramStoryContent data={data} />;
      default:
        return <InstagramTrackerSubContent data={data} />;
    }
  }, [data]);

  return getContent;
};

export default LandingPageMainContent;
